module.exports = __webpack_public_path__ + "static/media/no_dish_picture.4c227bdc.svg";